const CONFIG_CATEGORIES = {
  PACIENTE: `paciente`,
}

const CONFIG_KEYS = {
  PACIENTE: {
    ADMIT_SOCIAL_NAME: `admitSocialName`,
  },
}

export { CONFIG_CATEGORIES, CONFIG_KEYS }
